<template>
  <div class="notifications-dropdown">
    <b-nav-item-dropdown right no-caret style="list-style: none" class="m-0">
      <template v-slot:button-content class="notification-icon">
        <img src="@/assets/icons/icon-notification.svg" alt="logo" />
        <span
          v-if="getNotificaitonsCount"
          class="notification-count small count m-auto text-center"
        >
          {{ getNotificaitonsCount }}
        </span>
      </template>

      <b-dropdown-item v-if="!getNotificaitonsCount" class="d-block text-center p-3">
        <i class="material-icons full-icon align-middle">notifications</i>
        <p class="text-muted text-wrap">You don't have any notification yet.</p>
      </b-dropdown-item>

      <b-dropdown-item v-else>
        <b-list-group-item
          v-for="item in getNotifications.slice(0, 4)"
          class="darker-hover"
          :key="item.id"
          @click="read(item)"
          :class="!item.unread ? '' : userIsAParent ? 'bg-plain' : 'bg-plain2'"
        >
          <p class="m-0 text-wrap" :class="userIsAParent ? 'text-main' : 'text-main2'">
            {{ item.title }}
          </p>
          <small class="text-muted"
            >{{ formatDate(item.timestamp) }} - {{ formatHour(item.timestamp) }}</small
          >
        </b-list-group-item>
        <b-link
          @click="$router.push('/notifications')"
          class="text-center d-block py-2 small"
          :class="userIsAParent ? 'text-main' : 'text-main2'"
        >
          Show all
        </b-link>
      </b-dropdown-item>
    </b-nav-item-dropdown>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters('notifications', ['getNotifications', 'getNotificaitonsCount']),
    ...mapGetters('user', ['getUserId', 'userIsAParent']),
  },
  watch: {
    getNotifications: function() {
      // execute congrats component show function
      this.$root.$emit(
        'showComplexCongrats',
        this.getNotifications
          .filter((n) => n.title === 'Challenge approved' && n.unread)
          .map((n) => n.id),
        'newStars',
      );
      this.$root.$emit(
        'showComplexCongrats',
        this.getNotifications.filter((n) => n.title === 'Level up!' && n.unread).map((n) => n.id),
        'levelUp',
      );
    },
  },
  methods: {
    ...mapActions('notifications', ['markAsRead', 'fethNotifications']),
    formatDate(strdate) {
      var date = new Date(strdate);
      const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      var dayName = days[date.getDay()];
      var day = date.getDate();
      var monthName = months[date.getMonth()];
      //var year = date.getFullYear();
      day = day < 10 ? '0' + day : day;
      var formatted = `${dayName}, ${day} ${monthName}`;
      return formatted;
    },
    formatHour(strdate) {
      var date = new Date(strdate);
      var hours = date.getUTCHours();
      var minutes = date.getUTCMinutes();
      let ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;
      let strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    },
    read(item) {
      this.markAsRead(item.id).then(() => {
        this.fethNotifications({
          userIsAparent: this.userIsAParent,
          userId: this.getUserId,
        });
        if (item && item.child_id) {
          this.$store.commit('user/setChildrenSelectedId', item.child_id); //this.setChildrenSelectedId(item.child_id)
          sessionStorage.setItem('clickedChild', `{"id":${item.child_id},"enable":${false}}`);
        }
        if (this.$route.fullPath == item.url) {
          location.reload();
        } else {
          this.$router.push(item.url);
        }
      });
    },
  },
};
</script>
<style lang="scss">
* {
  position: relative;
  margin: 0px;
  padding: 0px;
}

.notifications-dropdown {
  .dropdown-item {
    padding: 0 !important;
  }

  a:hover {
    background: initial !important;
  }
}

.notification-icon {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  & > img {
    width: 25px;
    height: 25px;
  }
}

.notification-count {
  background-color: #f0142f;
  color: white;
  position: absolute;
  left: 12px;
  width: 20px;
  height: 20px;
  border-radius: 100%;
}
</style>
